import request from './request'

export const getGameCategorys = () =>
  request(
    {
      url: '/carbon-game/public/game/category/list',
      method: 'GET',
    },
    {
      skipTime: 30 * 1000,
    },
  )

export const getGameListByCategory = (params, options = {}) =>
  request(
    {
      url: '/carbon-game/public/game/info/page',
      method: 'GET',
      params,
    },
    options,
  )

export const getRoomList = (params, options = {}) =>
  request(
    {
      url: '/carbon-game/public/game/room/list',
      method: 'GET',
      params,
    },
    options,
  )

//  获取游戏链接
export const getGameUrl = (data: any) => {
  return request({
    url: '/carbon-game/private/user/game/login',
    method: 'POST',
    data,
  })
}

export const getFavoriteGameList = ({ pageIndex, pageSize, category, room, gameName }, options = {}) =>
  request(
    {
      url: '/carbon-game/private/user/game/favorite/page',
      method: 'GET',
      params: { pageIndex, pageSize, category, room, gameName },
    },
    options,
  )

export const queryFavoriteGameList = (options = {}) =>
  request(
    {
      url: '/carbon-game/private/user/game/favorite/list',
      method: 'GET',
    },
    options,
  )

export const getPlayedGameList = (params, options = {}) =>
  request(
    {
      url: '/carbon-game/private/user/game/played/page',
      method: 'GET',
      params,
    },
    options,
  )

export const createFavoriteGame = ({ code }, options = {}) =>
  request(
    {
      url: '/carbon-game/private/user/game/favorite/create',
      method: 'POST',
      data: { code },
    },
    options,
  )

export const deleteFavoriteGame = ({ code }, options = {}) =>
  request(
    {
      url: '/carbon-game/private/user/game/favorite/delete',
      method: 'POST',
      data: { code },
    },
    options,
  )
// 获取游戏启动图
export const getGameStartupDiagram = (params: any) =>
  request({
    url: '/carbon-misc/public/web/config/game/startup/diagram',
    method: 'GET',
    params,
  })
